import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import BusinessAreas from '../views/BusinessAreas.vue'
import JobSearch from '../views/JobSearch.vue'
import JobDetails from '../views/JobDetails.vue'
import Videos from '../views/Videos.vue'
import SpecificJobSearch from '../views/SpecificJobSearch.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'JobSearch',
    component: JobSearch,
  },
  {
    path: '/jobs',
    name: 'SpecificJobSearch',
    component: SpecificJobSearch,
  },
  {
    path: '/jobs/:id',
    name: 'JobDetails',
    component: JobDetails,
  },
  {
    path: '/business-areas',
    name: 'BusinessAreas',
    component: BusinessAreas,
  },
  {
    path: '/videos',
    name: 'Videos',
    component: Videos,
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const query = { ...to.query }
  let redirect = false
  const params = ['utm_source', 'ccuid']

  params.forEach(p => {
    if (from.query[p] && !to.query[p]) {
      query[p] = from.query[p]
      redirect = true
    }
  })

  if (redirect) {
    return next({
      path: to.path,
      query
    })
  }

  next()
})

export default router
